export default __webpack_public_path__ + "static/media/footer-email.9f2bcb30.svg";